import { createFileRoute } from '@tanstack/react-router';
import { Authn } from '@frontend/auth';
import { SsoSignInCallback } from '../../components';

export const Route = createFileRoute('/sso/callback')({
  component: SsoCallbackRouteComponent,
});

function SsoCallbackRouteComponent() {
  const auth: Authn = Route.useRouteContext({ select: (ctx) => ctx.auth });
  const navigate = Route.useNavigate();

  return <SsoSignInCallback<`/sso/callback`> {...{ auth, navigate }} />;
}
